import { defineStore } from 'pinia'
import {
  modelCollectionState,
  modelCollectionActions,
  modelCollectionGetters,
} from '@app/stores/ModelCollectionStore.ts'

import { useAnswerStore } from '@app/stores/AnswerStore.ts'

export const useQuestionStore = defineStore('QuestionStore', {
  state: () => modelCollectionState('questions'),
  getters: { ...modelCollectionGetters('questions', 'question') },
  actions: {
    ...modelCollectionActions('questions', 'question'),
    upsertQuestionsAndAnswers(questions) {
      this.upsertQuestions(questions)
      questions.forEach((question) => {
        useAnswerStore().upsertAnswers(question.answers)
      })
    },
  },
})
